import React, { useEffect, useState } from "react";
import Searchimg from "../../assets/images/search-icon.svg";
import { getDeviceIcon } from "../../utils/deviceIcons";
import useApi from "../../hook/useAPI";
import { DEVICE } from "../../utils/const";
import DeviceStatusBadge, { DeviceConnectionText } from "../DeviceStatus/DeviceStatusBadge";

export default function ZoneDeviceList({ zoneId, zoneName, onClose }) {
    const { getData } = useApi();
    const [deviceData, setDeviceData] = useState([]);

    useEffect(() => {
        const getDevice = async () => {
            try {
                const response = await getData(`${DEVICE.GET_ZONE_DEVICE_DETAILS}${zoneId}`);
                if (response.status == 200 && response?.data.length > 0) {
                    setDeviceData(response.data);
                } else {
                    console.log('Failed to fetch device details.');
                }
            } catch (err) {
                console.error("Error fetching device details:", err);
            }
        }
        getDevice();
    }, [zoneId])
    return (
        <>
            <div className="card new-background h-min-500">
                <div className="card-body new-card-body">
                    <div className="card">
                        <div className="card-body">
                            <div className="home-device-box">
                                <div className="top_bar">
                                    <div className="card_title"> {zoneName}</div>
                                    <div className="form_field_wrapper">
                                        <button className="url-button closebutton" onClick={onClose}>
                                            <i className="bi bi-x-circle"></i>
                                        </button>
                                    </div>
                                </div>
                                <div className="bottom_bar">
                                    <div className="search-box-wrap mb-3">
                                        <img className="search-box-icon" src={Searchimg} alt="" aria-hidden="true" />
                                        <input type="text" placeholder="Search or type a device name" />
                                    </div>
                                    <div className="device-list-box">
                                        {

                                            deviceData.map((item) => {
                                                return (

                                                    <div className="device-list border-0" key={item._id}>
                                                        <div className="d-flex align-items-center">
                                                            <div className="device-icon me-4"><img src={getDeviceIcon(item.deviceCategory)} alt="" /></div>
                                                            <div className="device-name">
                                                                <h5 className="ellipsis-text">{item.name}</h5>
                                                                <DeviceConnectionText device={item} />
                                                            </div>
                                                        </div>
                                                        <div className="ml-4" style={{ marginRight: 20 + "px" }}>
                                                            <DeviceStatusBadge device={item} />
                                                        </div>
                                                    </div>


                                                );

                                            })
                                        }
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

};